<template>
    <div >
      <div class="bg t-center flex flex-column vcenter" :style="{position:pageYOffset>=1900?'relative':'fixed','top':pageYOffset>=1900?'1900px':'45px'}">
          <!-- <img class='mainImg' :src="require('../../assets/product/warm/bg.png')"> -->
          <canvas class='canvas' id="02-head-bob-turn" width="1325" height="745"></canvas>
          <img class='mainText' :src="require('../../assets/product/warm/mainText.png')">
      </div>
      <div class='scaleImg'>
          <div class="row">
            <div :style="{position:'relative',transition:'all 0.2s',bottom:width>1200?'700px':'0'}">
                <img :src="require('../../assets/product/warm/scaleText.png')">
            </div>
            <img :style="{width:width + 'px',left:left + 'px',top:top + 'px' }" :src="require('../../assets/product/warm/scale.png')">
            <img :style="{bottom:width>=2000?width-1500+'px':'0',opacity:width>=2000?1:0, }" class='scaleNum' :src="require('../../assets/product/warm/scaleNum.png')">
          </div>
      </div>
      <div class="color-bg">
          <div class='left'></div>
          <div class='right'></div>
          <div class="changeColor">
                <div class='row flex flex-column  vcenter'>
                    <img class='img1' :src="require('../../assets/product/warm/img1.png')">
                    <img class='img2' :src="require('../../assets/product/warm/img2.jpg')">
                </div>
            </div>
            <div class="imgs">
                <div class="row flex">
                    <div >
                        <img class='img3' :src="require('../../assets/product/warm/img3.png')">
                    </div>
                    <div class="flex flex-column vcenter vend ml2">
                        <img class='img5' :src="require('../../assets/product/warm/img5.png')">
                        <img class='img6' :src="require('../../assets/product/warm/img6.png')">
                        <img class='img7' :src="require('../../assets/product/warm/img7.png')">
                    </div>
                </div>
                <!-- <img class='img4' :src="require('../../assets/product/warm/img4.jpg')"> -->
            </div>
      </div>
      
      <div class='bottom'>
            <div class="flex hcenter row">
                <div class="item t-center mx8 ">
                    <img :src="require('../../assets/product/introduce1.png')">
                    <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(201)'>超国标E1级环保</el-button></p> -->
                </div>
                <div class="py4 mx2"><el-divider direction='vertical' class='full-height'></el-divider></div>
                <div class="item t-center mx8 ">
                    <img :src="require('../../assets/product/introduce2.png')">
                    <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(202)'>A1级防火</el-button></p> -->
                </div>
                <div class="py4 mx2"><el-divider direction='vertical' class='full-height'></el-divider></div>
                <div class="item t-center mx8 ">
                    <img :src="require('../../assets/product/introduce3.png')">
                    <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(204)'>防水防潮</el-button></p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            width:1200,
            left:-100,
            top:0,
            pageYOffset:0,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScrollx,true);
        this.init();
    },
    methods: {
        handleScrollx(){
            this.pageYOffset  = window.pageYOffset;
            if(window.pageYOffset>3500){
                this.width = 1200 + (window.pageYOffset-3500)*2;
                this.left = (3500 - window.pageYOffset)-100;
                this.top = (window.pageYOffset-3500) * -1;
                if(window.pageYOffset>4100){
                    this.width = 1200 + (4100-3500)*2;
                    this.left = (3500 - 4100)-100;
                    this.top = (4100-3500) * -1;
                }
            }else{
                this.width = 1200;
                this.left = -100;
                this.top = 0;
            }
        },
        init() {
            this.initData();
            this.initImages();
            //this.handleResize();
            this.bindEvents();
            this.drawFirstCanvas();
        },
        initData() {
            this.canvas2 = document.getElementById("02-head-bob-turn");
            this.context = this.canvas2.getContext("2d");
            this.MAX_LEN = 21;
            this.imgs = [];
            this.imgs2 = [];
            this.start = 1;
            this.oldStart = -1;
            this.addN = 1;
            this.interval = 60; // 控制刷新率
            this.leftY = 0;
            this.curScrollY = this.getScrollTop();
            this.startPos = this.curScrollY;
            this.lastPos = this.curScrollY;
            this.isStop = false;
        },

        initImages() {
            for (let i = 1; i <= this.MAX_LEN; i++) {
                const img = new Image();
                // img.onload = () => this.imgs[i] = img
                img.src = this.getImage(i);
                // 不管加载否 保证顺序
                this.imgs.push(img);
            }
        },

        bindEvents() {
            //window.addEventListener("resize", () => this.handleResize());
            window.addEventListener("scroll", () => this.handleScroll());
        },

        getScrollTop() {
            return window.scrollY || 0;
        },

        getImage(num) {
        // const t = "A ("+ num+")";
            return require("../../assets/product/warm/WarmPlate ("+num+").png");
        },

        isOver() {
            return this.start < 0 || this.start > this.MAX_LEN - 1;
        },

        handleScroll() {
            const scrollY = this.getScrollTop();
            let delta = scrollY - this.curScrollY;
            const isDown = delta > 0;

            delta = Math.abs(delta) + this.leftY;
            this.curScrollY = scrollY;

            if (
                this.isStop &&
                isDown === this.needDown &&
                ((isDown && this.curScrollY > this.lastPos) ||
                (!isDown && this.curScrollY < this.lastPos))
            ) {
                this.isStop = false;
            }
            if (this.isStop) return;

            // good idea: 补偿
            const alpha = Math.floor(delta / this.interval) * this.addN || 0;
            this.leftY = delta % this.interval;

            isDown ? (this.start += alpha) : (this.start -= alpha);
            if (this.isOver() && !this.isStop) {
                // this.lastPos = scrollY
                this.isStop = true;

                // TODO: 多个 canvas 用 opacity 切换
                // this.canvas2.style.cssText = `opacity: 0;`
            }

            if (this.start < 0) this.start = 0;
            if (this.start > this.MAX_LEN - 1) this.start = this.MAX_LEN - 1;
            if (this.startPos >= scrollY) this.start = 0;
            if (this.oldStart === this.start) return;
            this.oldStart = this.start;
            // good idea：记录
            this.lastPos = scrollY;
            this.needDown = !isDown;
            if (scrollY > 1800) {
                return;
            }
            this.drawCanvas(this.start);
        },
        //初始化画第一帧，需要在图片加载完成之后再进行canvas画图
        drawFirstCanvas(){
            const imgTemp = this.imgs[0];
            const canvas = this.canvas2;
            canvas.width = 1325;
            canvas.height = 745;
            let that = this;
            imgTemp.onload = function(){
                that.context.drawImage(imgTemp, 0, 0, canvas.width, canvas.height);
            }
        },
        drawCanvas(sequence) {
            // 当前序列帧
            const imgTemp = this.imgs[sequence];
            const canvas = this.canvas2;
            canvas.width = 1325;
            canvas.height = 745;
            if(imgTemp){
                this.context.drawImage(imgTemp, 0, 0, canvas.width, canvas.height);
            }
        },
        
    },
    //离开页面时销毁
    beforeDestroy(){
        window.removeEventListener("scroll",this.handleScrollx)
    }


}
</script>

<style lang='scss' scoped>

    .bg{
        width: 100%;
        height: 1100px;
        min-height: 100vh;
        z-index: 1;
        overflow: hidden;
        background: white;
        .canvas{
            position: relative;
            top:-30px;
            left: 47px;
        }
        .mainText{
            margin:-50px auto -150px auto;
        }
        // .mainImg{
        //     width: 1325px;
        //     margin-left:70px;
        // }
    }
    .scaleImg{
        padding:206px 0;
        overflow: hidden;
        height: 1815px;
        margin-top:1900px;
        .row{
            width: 800px;
            margin: 0 auto;
            div{
                width: 870px;
                span{
                    line-height: 38px;
                    letter-spacing: 1px;
                }
            }
            img{
                transition:all;
                position: relative;
            }
            .scaleNum{
                position: relative;
                left:-210px;
                bottom:0px;
                opacity: 0;
                transition:all 0.1s;
            }
        }
    }
    .color-bg{
        position: relative;
        .left{
            position: absolute;
            width: 50%;
            height: 100%;
            background-color: #D39D55;
            z-index: -1;
        }
        .right{
            position: absolute;
            left:50%;
            width: 50%;
            height: 100%;
            background-color: #506CAD;
            z-index: -1;
        }
        .changeColor{
            background-size: 100%;
            height: 860px;
            .row{
                width: 1200px;
                margin: 0px auto;
                .img1{
                    z-index: 2;
                    margin:125px auto -50px auto;
                }
                .img2{
                    width: 100%;
                    margin:0 auto;
                }
            }
        }
    }
    
    .imgs{
        padding-top:206px;
        background-image: url("../../assets/product/warm/img4.jpg");
        background-size: 1903px;
        height: 800px;
        background-position: center;
        background-repeat: no-repeat;
        .row{
            width: 1000px;
            margin: 50px auto;

            div{
                .img3{
                    width: 500px;
                }
                .img5{
                    width: 500px;
                }
                .img6{
                    width: 600px;
                }
                .img7{
                    width: 300px;
                }
            }
            
        }
    }
    .bottom{
      border-top: 1px solid #DEDEDE;
      border-bottom: 1px solid #DEDEDE;
      .row{
          width: 60%;
          margin: 40px auto;
          .item{
            img{
              width: 90px;
            }
          }
      }
    }

</style>